import React from "react"
import MainCP from "../../../Components/industrias/industrias-v2/MainCP"

const ViewIndustrias: React.FC = () => <MainCP/>

export default ViewIndustrias;